module.exports = __webpack_public_path__ + "img/arrow-down.a3c6487d.svg";